import React from 'react';
import Modal from './common/Modal/Modal';
import Button from './common/Button/Button';

interface Props {
  isShow: boolean;
  onRequestClose: () => void;
  handleClickApprove: () => void;
}

const ModalApproval: React.FC<Props> = ({
  isShow,
  onRequestClose,
  handleClickApprove,
}) => {
  return (
    <Modal
      size="sm"
      isShow={isShow}
      title="Bridge Approval"
      onClose={onRequestClose}
      explanation={
        <>
          Approval processing is needed to approve the K STADIUM bridge and
          allow token transfers.
          <br />
          Upon approval, access is granted to the conversion amount of the
          selected token in the K STADIUM wallet.
          <br />* when using approve, a transaction fee will be incurred.
        </>
      }
      footerComponent={<Button onClick={handleClickApprove} title="Approve" />}
    />
  );
};

export default ModalApproval;
